import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ASSIGN_TRANSACTION_UUID, ASSIGN_USER_UUID, INITIALIZE_SESSION_UUID, INITIATE_PURCHASE, PURCAHSE_IN_PROGRESS, SET_ACTION_TRIGGER } from '../actions/types';
var initialState = {
  initiatePurchase: false,
  transaction_uuid: '',
  actionTrigger: '',
  session_uuid: '',
  user_uuid: '',
  purchase_in_progress: false
};
export var purchaseReducer = function purchaseReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case INITIATE_PURCHASE:
      return _objectSpread(_objectSpread({}, state), {}, {
        initiatePurchase: action.payload
      });
    case ASSIGN_TRANSACTION_UUID:
      return _objectSpread(_objectSpread({}, state), {}, {
        transaction_uuid: action.payload
      });
    case SET_ACTION_TRIGGER:
      return _objectSpread(_objectSpread({}, state), {}, {
        actionTrigger: action.payload
      });
    case PURCAHSE_IN_PROGRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        purchase_in_progress: action.payload
      });
    case INITIALIZE_SESSION_UUID:
      return _objectSpread(_objectSpread({}, state), {}, {
        session_uuid: action.payload
      });
    case ASSIGN_USER_UUID:
      return _objectSpread(_objectSpread({}, state), {}, {
        user_uuid: action.payload
      });
    default:
      return state;
  }
};